"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _links = require("self-service-api/core/utilities/links");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var UIAccountSummaryButton = function UIAccountSummaryButton(props) {
  var trackingSource = props.trackingSource;
  var propsToPass = (0, _utils.omit)(props, ['trackingSource', 'upgradeData']);

  var handleClick = function handleClick() {
    tracker.track('externalLinkClick', {
      name: 'account-summary',
      trackingSource: trackingSource
    });
  };

  return _react.default.createElement(_UIButton.default, (0, _extends2.default)({
    href: (0, _links.getAccountDashboardUrl)(),
    onClick: handleClick,
    target: "_blank",
    truncate: true
  }, propsToPass), _react.default.createElement(_FormattedMessage.default, {
    message: "upgrades.viewAccountButton.text"
  }));
};

var _default = UIAccountSummaryButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/button/UIAccountSummaryButton.js
// module id = 777
// module chunks = 5 6